$(function(){

	// if ($('#map').length) {
	// 	let myMap,
	// 	myPlacemark,
	// 	fullScreen = false,
	// 	$map = $('#map'),
	// 	coordinates = JSON.parse(JSON.stringify($map.data('coordinates'))),
	// 	icon = $map.data('icon');


	// 	function initMap() {
	// 	  let map = new google.maps.Map(document.getElementById('map'), {
	// 		zoom: 14,
	// 		center: coordinates,
	// 		mapTypeControl: false,
	// 		navigationControl: false,
	// 		streetViewControl: false,
 //   			mapTypeId: google.maps.MapTypeId.ROADMAP,
	// 		styles: [{"featureType":"all","elementType":"geometry","stylers":[{"saturation":"0"},{"lightness":"0"},{"visibility":"on"},{"gamma":"1"}]},
	// 			{"featureType":"all","elementType":"labels.text.fill","stylers":[{"saturation":1},{"color":"#555555"},{"lightness":1}]},
	// 			{"featureType":"all","elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#333333"},{"lightness":"0"}]},
	// 			{"featureType":"all","elementType":"labels.icon","stylers":[{"visibility":"off"}]},
	// 			{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"lightness":20},{"visibility":"on"}]},
	// 			{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"lightness":17},{"weight":1.2},{"visibility":"on"}]},
	// 			{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#333333"},{"lightness":"0"},{"visibility":"on"},{"weight":"1.00"},{"gamma":"1"}]},
	// 			{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#333333"},{"lightness":"0"}]},
	// 			{"featureType":"poi.attraction","elementType":"geometry","stylers":[{"visibility":"on"}]},
	// 			{"featureType":"poi.attraction","elementType":"geometry.fill","stylers":[{"visibility":"on"}]},
	// 			{"featureType":"poi.attraction","elementType":"geometry.stroke","stylers":[{"visibility":"on"}]},
	// 			{"featureType":"poi.business","elementType":"geometry.fill","stylers":[{"visibility":"on"}]},
	// 			{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"lightness":"0"},{"color":"#333333"}]},
	// 			{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#333333"},{"lightness":"0"},{"weight":0.2},{"visibility":"on"}]},
	// 			{"featureType":"road.highway.controlled_access","elementType":"geometry.fill","stylers":[{"color":"#333333"},{"visibility":"on"}]},
	// 			{"featureType":"road.arterial","elementType":"geometry","stylers":[{"lightness":"0"},{"visibility":"on"},{"color":"#2E2E2E"}]},{"featureType":"road.arterial","elementType":"geometry.fill","stylers":[{"color":"#2E2E2E"}]},
	// 			{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#282828"},{"lightness":"0"}]},
	// 			{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#282828"},{"lightness":"0"},{"visibility":"on"}]},
	// 			{"featureType":"water","elementType":"geometry","stylers":[{"color":"#2B2B2B"},{"lightness":"0"}]}]
	// 	  });
	// 	  let image = icon;
	// 	  let beachMarker = new google.maps.Marker({
	// 		position: coordinates,
	// 		map: map,
	// 		icon: image
	// 	  });
	// 	}

	// 	initMap();
	// }


	if($('#map').length) {


		let map = $('#map');
		let coordinates = JSON.parse(JSON.stringify(map.data('coordinates')));
		let icon = map.data('icon');


		function init() {

			// Создаем карту.
			let myMap = new ymaps.Map("map",
				{
					center: [coordinates.lat, coordinates.lng],
					zoom: 15.2,
					yandexMapDisablePoiInteractivity: true,
					suppressObsoleteBrowserNotifier:true,
					suppressMapOpenBlock: true,
					controls: ['zoomControl']
				},
				{
					searchControlProvider: 'yandex#search'
				}),

				myPlacemark = new ymaps.Placemark(myMap.getCenter(), {
					hintContent: '',
					balloonContent: ''
				}, {
					iconLayout: 'default#image',
					iconImageHref: icon,
					iconImageSize: [48, 37],
					iconImageOffset: [-34 , -18]
				})
			myMap.geoObjects
				.add(myPlacemark);

			myMap.panes.get('ground').getElement().style.filter = 'grayscale(100%) invert(100%)';
			myMap.controls.add(zoomControl);
			myMap.behaviors.disable('scrollZoom');
		}

		ymaps.ready(init);

	}

})
